import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import FormPage from "./pages/FormHandlers/FormPage";
import Signup from "./pages/Auth/Signup";
import Signin from "./pages/Auth/Signin";
import Otp from "./pages/Auth/Otp";
import { URLS } from "./config/url";
import FinishRegistration from "./pages/FormHandlers/FinishRegistration";
// import SetEmailPage from "./pages/SetEmail";
import { useTokenManager } from "./hooks/useTokenManager";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import Landing from "./pages/home";
import Register from "./pages/register";
import Program from "./pages/program";
import Contact from "./pages/contact";


// ScrollToTop component to reset scroll position on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, [pathname]); // Triggered on every route change

  return null;
};

// ProtectedRoute component to handle token validation and redirection

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  // Function to refresh the access token
  const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      return null;
    }

    try {
      const response = await fetch(`${URLS}/api/user/refreshToken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ refreshToken }),
      });

      const json = await response.json();

      if (!response.ok) {
        // throw new Error(json.error || "Failed to refresh token");
        navigate("/signin"); // Redirect to signin if refresh fails
        return null;
      }

      const accessTokenExpires = Date.now() + 3 * 60 * 1000; // 3 minutes
      localStorage.setItem("accessToken", json.accessToken);
      localStorage.setItem("accessTokenExpires", accessTokenExpires.toString());
      if (json.refreshToken) {
        localStorage.setItem("refreshToken", json.refreshToken);
      }
      return json.accessToken;
    } catch (err) {
      console.error("Refresh token error:", err);
      return refreshToken;
    }
  };

  // Check token validity
  const isAuthenticated = () => {
    const accessToken = localStorage.getItem("accessToken");
    const expires = localStorage.getItem("accessTokenExpires");

    if (!accessToken || !expires) {
      return false;
    }

    if (Date.now() > parseInt(expires)) {
      // Access token expired, try refreshing
      return refreshAccessToken() !== null;
    }

    return true;
  };

  // Use useEffect to handle async refresh token logic
  useEffect(() => {
    const checkAuth = async () => {
      const accessToken = localStorage.getItem("accessToken");
      const expires = localStorage.getItem("accessTokenExpires");

      if (accessToken && expires && Date.now() > parseInt(expires)) {
        const newToken = await refreshAccessToken();
        // if (!newToken) {
        //   navigate("/signin"); // Redirect to signin if refresh fails
        // }
      }
    };

    checkAuth();
  }, [navigate]);

  return isAuthenticated() ? children : <Navigate to="/signin" replace />;
};

// Layout component with API call and conditional routing
function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const isSignupPage = location.pathname === "/signup";
  const isSignInPage = location.pathname === "/signin";
  const isVerifyOtp = location.pathname === "/verify-otp";
  const isForgotPassword = location.pathname === "/forgot-password";
  const isResetPassword = location.pathname.startsWith("/reset-password/");
  const { getValidAccessToken } = useTokenManager();

  // Fetch getMyInfo API on mount

  useEffect(() => {
    const fetchMyInfo = async () => {
      try {
        const accessToken = await getValidAccessToken();
        setSubscriptionLoading(true);
        if (!accessToken) {
          return;
        }

        const response = await fetch(`${URLS}/api/registerUser/getMyInfo`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Network error, please try again");
        }

        const data = await response.json();
        // Set subscription data
        if (data.subscription !== null) {
          setSubscriptionLoading(false);
          setSubscription(data.toUpperCase());
        }
        // Redirect based on subscription status
        if (data.subscription !== null) {
          setSubscriptionLoading(false);

          if (location.pathname === "/") {
            setSubscriptionLoading(false);
            navigate("/ticket");
          }
        }
        if ((data.message == "No user found", "subscription")) {
          setSubscriptionLoading(false);
        }
      } catch (error) {
        // console.error("Error fetching getMyInfo:", error);
        setSubscription(null);
      }
    };

    fetchMyInfo();
  }, [navigate, location.pathname]); // Added location.pathname to recheck on route change

  return (
    <div className="min-h-screen flex flex-col">
      {!isSignupPage &&
        !isSignInPage &&
        !isVerifyOtp &&
        !isForgotPassword &&
        !isResetPassword && (
            <Header
              subscriptionLoading={subscriptionLoading}
              subscription={subscription}
            />
        )}
      <main className="flex-grow">
        <Routes>
          <Route
            path="/"
            element={
              subscription !== null ? (
                <Navigate to="/home" replace />
              ) : (
                <Landing />
              )
            }
          />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/verify-otp" element={<Otp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          {/* <Route path="/partnerPage" element={<PartnerPage />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route
            path="/edit-profile"
            element={
              <ProtectedRoute>
                <EditProfile />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment
                  subscriptionLoading={subscriptionLoading}
                  mySubscription={subscription}
                />
              </ProtectedRoute>
            }
          />
       

          <Route
            path="/ticket"
            element={
              <ProtectedRoute>
                <Tickets />
              </ProtectedRoute>
            }
          /> */}

          <Route
            path="/finish_registration"
            element={
              <ProtectedRoute>
                <FinishRegistration
                  subscriptionLoading={subscriptionLoading}
                  mySubscription={subscription}
                />
              </ProtectedRoute>
            }
          />
{/* 
          <Route
            path="/participantForm"
            element={
              <ProtectedRoute>
                <ParticipantForm />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/register"
            element={
                <Register />
            }
          />
          <Route
            path="/program"
            element={
                <Program />
            }
          />
          <Route
            path="/contact"
            element={
                <Contact />
            }
          />
        
          <Route
            path="/form"
            element={
              <ProtectedRoute>
                <FormPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!isSignupPage &&
        !isSignInPage &&
        !isVerifyOtp &&
        !isForgotPassword &&
        !isResetPassword && <Footer />}
    </div>
  );
}

function App() {
  return (

      <Router>
        <ScrollToTop />
        <Layout />
      </Router>
  );
}

export default App;
